import { NotificationAlert } from 'core/classes/NotificationAlert';
import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { coreActions } from '../actions/coreActions';
import { AxiosError } from 'axios';
import { ResponseStatus } from 'core/classes/ResponseStatus';
import { larvaActions } from 'smartHome/larva/redux/actions/larvaActions';
import { setLogout, requestToRefreshExpiredToken } from 'tenantUser/redux/authActions';
import { isEmpty } from 'lodash';

const NOTIFICATIONS = {
    refreshing: 'One moment, refreshing...',
    uniqueCard: 'notices.card must be unique',
    easyPin: 'notices.PIN is too easy to guess',
    criticalError: 'notices.criticalError',
};

export const handleErrorResponse = (dispatch: Dispatch<AnyAction>, reason: unknown, action: AnyAction) => {
    const response = (reason as AxiosError)?.response;

    let message = '';
    let level = NotificationAlert.ERROR;

    console.log('[Error in response]', response?.data?.errors);
    console.log('[Response]', response);

    if (ResponseStatus.isInvalidRefreshTokenMessage(response?.data?.message)) {
        dispatch(setLogout());
        return;
    }

    if (
        ResponseStatus.isUnauthorizedCode(response?.status) ||
        ResponseStatus.isInvalidAccessTokenMessage(response?.data?.message)
    ) {
        message = NOTIFICATIONS.refreshing;
        level = NotificationAlert.WARNING;

        dispatch(requestToRefreshExpiredToken());

        if (action) {
            dispatch(larvaActions.queueAction(action));
        }
    }

    if (/card must be unique/i.test(`${response?.data?.message}`)) {
        message = NOTIFICATIONS.uniqueCard;
    }

    if (/PIN is too easy to guess/i.test(`${response?.data?.message}`)) {
        message = NOTIFICATIONS.easyPin;
    }

    if (response?.data?.errors && !isEmpty(response?.data?.errors)) {
        const errors = response.data.errors;

        if (errors.some((error: { message: string }) => /Internal server Error/i.test(error.message))) return;

        message = response?.data?.errors?.[0]?.message;
    }

    dispatch(
        coreActions.notification.set(
            new NotificationAlert({
                message: message || response?.data?.message || NOTIFICATIONS.criticalError,
                level: level,
            }).all,
        ),
    );
};
